function AthComponent(Ele:any,code:string) {
    if (window.location.href.indexOf('?code=') > 0 && window.location.href.indexOf('&state=') > 0) {
        window.location.hash='#/confirmLogin'
    }
    return <Ele></Ele>
}
export default AthComponent;
